<template>
  <el-menu
    ref="mainMenu"
    class="main-menu responsive-visible"
    :class="this.device"
    :default-active="activeIndex"
    :collapse="isCollapsed"
    :router="true"
    :unique-opened="true"
    @select="onSelectMenu"
  >
    <div class="top-bar-left">
      <img
        class="item-icon"
        src="/image/FIFLBOX-LOGO.png"
      >
      <span
        class="icon ic-close"
        @click="handleClickClose"
      />
    </div>
    <el-menu-item
      v-if="isDashboardMenuVisible"
      index="/dashboard"
    >
      <img
        class="item-icon"
        src="/image/selected/dashboard.png"
      >
      <span class="title">
        대시보드
      </span>
    </el-menu-item>

    <el-submenu
      v-if="isScheduleMenuVisible || isTimetableMenuVisible"
      index="/course"
    >
      <template slot="title">
        <img
          class="item-icon"
          src="/image/selected/class.png"
        >
        <span class="title">
          수업
        </span>
      </template>
      <el-menu-item
        v-if="isScheduleMenuVisible"
        index="/course/schedule"
      >
        스케줄
      </el-menu-item>
      <el-menu-item
        v-if="isTimetableMenuVisible"
        index="/course/timetable"
      >
        시간표 제작
      </el-menu-item>
    </el-submenu>

    <el-submenu
      v-if="isRegisteredMemberMenuVisible ||
        isPendingMemberMenuVisible ||
        isCreateMemberMenuVisible"
      index="/member"
    >
      <template slot="title">
        <img
          class="item-icon"
          src="/image/selected/members.png"
        >
        <span class="title">
          회원
        </span>
      </template>
      <el-menu-item
        v-if="isRegisteredMemberMenuVisible"
        index="/member/valid"
      >
        유효 회원
      </el-menu-item>
      <el-menu-item
        v-if="isRegisteredMemberMenuVisible"
        index="/member/expired"
      >
        만료 회원
      </el-menu-item>
      <el-menu-item
        v-if="isPendingMemberMenuVisible"
        index="/member/waiting"
      >
        승인 대기 회원
      </el-menu-item>
      <el-menu-item
        v-if="isCreateMemberMenuVisible"
        index="/member/register"
      >
        회원 등록
      </el-menu-item>
    </el-submenu>
    <el-menu-item
      v-if="isAnalyticsMenuVisible"
      index="/analytics"
    >
      <img
        class="item-icon"
        src="/image/selected/analytics.png"
      >
      <span class="title">
        통계
      </span>
    </el-menu-item>
    <el-menu-item
      v-if="isLockerMenuVisible"
      index="/locker"
    >
      <img
        class="item-icon"
        src="/image/selected/locker.png"
      >
      <span class="title">
        락커
      </span>
    </el-menu-item>
    <el-menu-item
      v-if="!isLightGreyPlan && isNoticeMenuVisible"
      index="/notices"
    >
      <img
        class="item-icon"
        src="/image/selected/notice.png"
      >
      <span class="title">
        공지
      </span>
    </el-menu-item>
    <el-submenu
      v-if="isSettingMenuVisible"
      index="/setting"
      popper-class="subm"
    >
      <template slot="title">
        <img
          class="item-icon"
          src="/image/selected/setting.png"
        >
        <span class="title">
          설정
        </span>
      </template>
      <el-menu-item index="/setting/policy">
        운영 정책
      </el-menu-item>
      <el-menu-item index="/setting/course">
        수업
      </el-menu-item>
      <el-menu-item index="/setting/membership">
        회원권
      </el-menu-item>
      <el-menu-item 
        v-if="isOwnerAccount"
        index="/setting/instructor"
      >
        강사
      </el-menu-item>
    </el-submenu>
    <el-menu-item
      v-if="isWhitePlan"
      disabled
    >
      <img
        class="item-icon"
        src="/image/selected/database.svg"
      >
      <span slot="title">
        무료 이용 인원 제한
        <popover>
          회원 49명까지 무료로 등록할 수 있습니다.<br>  
          ‘승인된’ 회원 기준이며 이후 회원을 삭제하더라도<br>
          인원수는 변동되지 않습니다. 더 많은 회원을 등록<br>
          하려면 유료 플랜을 결제해 주세요.
        </popover>
      </span>
    </el-menu-item>
    <section
      v-if="isWhitePlan"
      v-show="!isCollapsed "
      class="el-wrapper__limit-gauge"
    >
      <div class="limit-gauge">
        <div :style="{width: `${Math.min((centerAccount.approval_members / 49) * 100, 100)}%` }" />
      </div>
      <strong class="approval-message">
        {{ centerAccount.approval_members }}명 승인 완료
      </strong>
      <button
        class="plan-bill-button"
        @click.prevent="handleClickPlanBillBtn"
      >
        유료 플랜 결제
      </button>
    </section>
  </el-menu>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';
import Popover from '@/components/popover.vue';

export default {
  name: 'MainMenu',
  components: { Popover },
  props: {
    isCollapsed: {
      default: false
    },
    isClosed: {
      default: false
    },
    device: {
      default: 'desktop'
    }
  },
  data() {
    return {
      activeIndex: '/'
    };
  },
  computed: {
    ...computedGetters([
      'role',
      'isOwnerAccount',
      'isDashboardMenuVisible',
      'isScheduleMenuVisible',
      'isTimetableMenuVisible',
      'isAnalyticsMenuVisible',
      'isLockerMenuVisible',
      'isRegisteredMemberMenuVisible',
      'isPendingMemberMenuVisible',
      'isCreateMemberMenuVisible',
      'isNoticeMenuVisible',
      'isCreateWodButtonVisible',
      'isSettingMenuVisible',
      'isWhitePlan',
      'isLightGreyPlan',
      'centerAccount'
    ])
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.activeIndex = this.$route.name.split('main')[1];
      }
    }
  },
  methods: {
    onSelectMenu() {
      this.$emit('close');
      this.$emit('update:isClosed', true);
    },
    handleClickClose() {
      this.$emit('close');
    },
    handleClickPlanBillBtn() {
      window.open('https://bit.ly/3qv0GAo');
    }
  }
};
</script>

<style lang="scss">
.main-menu {
  .title {
    display: inline-block;
  }

  &.desktop {
    min-height: 100%;

    &:not(.el-menu--collapse) {
      width: 320px;
    }

    .ic-close {
      display: none;
    }
  }

  &.mobile {
    &:not(.el-menu--collapse) {
      width: 100% !important;
    }

    .ic-close {
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }

  &.el-menu {
    border-right: 0;
  }

  &.el-menu--collapse {
    width: 72px;

    .el-menu-item {
      padding-left: 17px;

      div {
        padding-left: 17px;
      }
    }
  }

  .item-icon {
    margin-right: 23px;
  }

  .el-menu-item {
    font-size: 16px;
    border-left: 2px solid white;
    color: #b9b9b9;

    span {
      width: 153px;
      display: inline-block;
      &.el-popover__reference-wrapper {
        margin-left: 0px;
        width: initial;
      }
    }

    &.is-active {
      color: #4a4a4a;
      border-left: 2px solid black;
    }

    &.is-disabled {
      opacity: 1;
      color: #b9b9b9;
      cursor: pointer;
    }
  }

  .el-submenu {
    .el-submenu__title {
      border-left: 2px solid white;
      color: #b9b9b9;
      span {
        font-size: 16px;
      }
    }

    &.is-active {
      .el-submenu__title {
        color: #4a4a4a;
        border-left: 2px solid black;
      }
    }

    .el-menu {
      background-color: #fcfcfc;

      .el-menu-item {
        border: none;
        font-size: 14px;
        padding-left: 75px !important;
      }
    }
  }

  .el-wrapper__limit-gauge {
    display: flex;
    flex-direction: column;
    padding-left: 75px;
    width: 100%;
    padding-bottom: 30px;
    width: calc(100% - 75px);
    .limit-gauge {
      width: calc(100% - 35px);
      position: relative;
      height: 12px;
      background-color: #f2f2f2;
      border-radius: 6px;
      overflow: hidden;
      margin-bottom: 5px;
      div {
        position: absolute;
        background-color: #9b9b9b;
        height: 100%;
        border-radius: 6px;
      }
    }

    .approval-message {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: -0.69px;
      color: #9b9b9b;
      margin-bottom: 15px;
    }

    .plan-bill-button {
      cursor: pointer;
      width: 109px;
      height: 42px;
      padding: 10px 0;
      border-radius: 8px;
      border: solid 1.5px #9b9b9b;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: -0.86px;
      text-align: center;
      color: #9b9b9b;
      background-color: inherit;
      &:hover {
        background-color: #9b9b9b;
        color: #fff;
      }
    }
  }

  @media screen and (max-width: 768px) {
  }
}
</style>
